import React from 'react';
import { Target } from 'lucide-react';

// objects: [{ object, amount }] from utils/issueSubscription.js buildIssuerProfile
export const IssueObjects = ({ objects, detailPath }) => (
  <section aria-labelledby="objects-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5 flex flex-col">
    <h2 id="objects-heading" className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
      <Target className="w-4 h-4 text-[#008080]" aria-hidden="true" />
      Objects of the Issue
    </h2>
    <p className="mt-1 text-[11px] text-slate-500">How the company plans to use the money raised, as stated in the offer document.</p>

    {objects.length ? (
      <ol className="mt-3 space-y-2">
        {objects.map((item, index) => (
          <li key={item.object} className="flex gap-2.5 rounded-xl border border-slate-200 bg-slate-50/60 p-3">
            <span className="w-5 h-5 rounded-md bg-slate-900 text-white text-[10px] font-extrabold flex items-center justify-center flex-shrink-0">
              {index + 1}
            </span>
            <div className="min-w-0">
              <p className="text-xs font-semibold text-slate-800 leading-snug">{item.object}</p>
              {item.amount && <p className="mt-0.5 text-[11px] font-bold text-[#008080]">Earmarked: {item.amount}</p>}
            </div>
          </li>
        ))}
      </ol>
    ) : (
      <p className="mt-3 flex-1 flex items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50 px-3 py-6 text-center text-xs text-slate-500">
        {detailPath
          ? 'The use of proceeds hasn’t been extracted from this company’s offer document yet.'
          : 'This company’s offer document isn’t in our registry yet.'}
      </p>
    )}
  </section>
);

export default IssueObjects;
